<template>
	<div class="ssopage">		
		<div class="d-flex mb-4" v-if="!podbor">
			<div class="btn-group btn-group-toggle" data-toggle="buttons">
				<label
					v-for="(option, index) in market.marketActions"
					:key="option.name"
					class="btn btn-sm btn-primary btn-simple"
					:class="{ active: market.activeIndex === index }"
					:id="index"
				>
					<input
						type="radio"
						@click="initTabAction(index)"
						name="options"
						autocomplete="off"
						:checked="market.activeIndex === index"
					/>
					<span class="d-none d-sm-block">{{ option.name }}</span>
					<span class="d-block d-sm-none"><i :class="option.icon"></i></span>
				</label>
				
			</div>
			<div class="ml-2 mt-1 labelMobile"><h6 v-if="market.activeIndex==0" class="mb-0">Новостройки</h6><h6 v-if="market.activeIndex==1" class="mb-0">Вторичный рынок</h6></div>
		</div>

		<template v-if="market.activeIndex==0">
			<ssonewbuildings />
		</template>
		<template v-else-if="market.activeIndex==1">
			<ssosecondbuildings />
		</template>

	</div>
</template>
<script>
/*
Нужно продумать структуру Модулей БП
- У задачи будет в типе завершения новые типы, по которым мы будем понимать отношение к тому или иному модулю
Пример: Новый тип завершения - Отправка объектов новостроя
В случае, если будет выставлен этот тип, задача будет иметь конпку "Подобрать", которая будет вести на страницу с фильтром по новострою с сохранением объектов в "избранное" и отправку из "Избранного" клиенту. То есть этот модуль должен иметь:
1. Базу новостроек АБС
2. Данные о клиенте (в т.ч. контактные данные) для высылания
3. Чек-лист потребностей клиента, который будет предзаполнять фильтр (фильтр можно скорректировать, но изначально заполнятется потребностями.

Если пользователь начал подбирать объекты клиенту и не закончил, они должны быть сохранены именно на конкретном клиенте. То есть если начать подбирать другому клиенту объекты в этом модуле, то это должно быть другое избранное.

После высылания объектов клиенту со статусом "Успех" (кнопка "Выслать клиенту"), система должна вернуть пользователя на страницу клиента 

В структуре надо предосмотреть что мы будем реализовывать типовые модули для других рынков. Модуль не должен быть привязан к услуге, он должен быть привязан к типу завершения задачи.
*/

import ssonewbuildings from "src/our_modules/SearchSendObjects/sso_newbuildings.vue";
import ssosecondbuildings from "src/our_modules/SearchSendObjects/sso_secondbuildings.vue";


export default {
	name: 'sso-page',
	components: {
		ssonewbuildings,
		ssosecondbuildings,
	},
	data() {
		return {
			market: {
				activeIndex: 0,
				marketActions: [
					{ id: '0', name: 'Новостройки', icon: 'tab-icon tim-ic ic-gk-building' },
					{ id: '1', name: 'Вторичный рынок', icon: 'tim-icons icon-istanbul' }
				]
			},		
			
		};
	},
	watch: {

	},
	computed: {

	},
	methods: {
		setDefaultUrl(masDefaultParams){
			let queryParams = new URLSearchParams('');
			for (let i = 0; i < masDefaultParams.length; i++) {
				queryParams.append(masDefaultParams[i][0],masDefaultParams[i][1]);
			}
			history.replaceState(null, null, "?"+queryParams.toString());
		},
		initTabAction(index) {
			this.market.activeIndex = index;
			if(index==0){
				let masDefaultParams = [];
				masDefaultParams.push(['dSearchType','complex']);
				masDefaultParams.push(['dSortType','dt_upd|d']);
				masDefaultParams.push(['dSortOrder','d']);
				masDefaultParams.push(['AddComplexMinFlatsBig','1']);
				masDefaultParams.push(['dnotworkgk','0']);
				this.setDefaultUrl(masDefaultParams);
			}
			if(index==1){
				let masDefaultParams = [];
				masDefaultParams.push(['dSearchType','flats']);
				masDefaultParams.push(['dSortType','dt_upd|d']);
				masDefaultParams.push(['dSortOrder','d']);
				this.setDefaultUrl(masDefaultParams);
			}
		},
	},
	mounted() {
		
	},
	created(){
		let objGetParams = this.$GVO.GetAllGet();
		this.podbor=objGetParams.hasOwnProperty('task_id'); // Если пришёл код задачи, то это подбор и не показывает кнопки переключения рынков
		if(typeof objGetParams.dSearchType != 'undefined'){
			if(['flats','flatmap'].indexOf(objGetParams.dSearchType) !==-1){
				this.market.activeIndex = 1;
			}else{
				this.market.activeIndex = 0;
			}
		}
	}
};
</script>
<style scoped>
.labelMobile {
	display: none;
}

@media (max-width: 575px){
	.labelMobile {
		display: flex;
		align-items: center;
	}
}
</style>

